export default __webpack_public_path__ + "pgnv-assets/caa36f1a9f40e9ff098e1bac164143ce.svg";